// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert_section_container__x45qL {
    font-family: Mulish, sans-serif;
}

.alert_section_header__EBKN5 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    color: #8BA1D4CC;
    font-size: 24px;
    font-weight: 600;
}

.alert_section_body__GdFNr {
    overflow-y: scroll;
}

.alert_section_section__nSllO {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
}

.alert_section_day__BEPlA {
    flex-basis: 20%;
}

.alert_section_alerts__H\\+MsQ {
    flex-basis: 75%;
}

.alert_section_alert__Fzi6l {
    background-color: #FFFFFF;
    border-radius: 12px;
    display: flex;
    padding: 12px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.alert_section_alertTitle__L8cMi {
    font-size: 14px;
    font-weight: 600;
    text-align: left;
}

.alert_section_alertTitle__L8cMi div:last-of-type {
    color: #8C8C8C;
    font-size: 12px;
    font-weight: 500;
}

.alert_section_alertDay__w\\+cPM {
    color: #8C8C8C;
    font-size: 12px;
    font-weight: 600;
}

.alert_section_alertValue__xJVQa {
    background-color: #F5F5F5;
    font-size: 24px;
    font-weight: 600;
    display: flex;
    align-items: center;
    vertical-align: bottom;
    border-radius: 8px;
    padding: 10px 12px;

}

.alert_section_alertValue__xJVQa div:last-of-type {
    padding-left: 4px;
    color: #B7B7B7;
    font-size: 16px;
    font-weight: 600;
}

.alert_section_alertDate__gc-jo {
    color: #6A86C8;
    font-size: 24px;
    font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/screens/detail/components/sections/alert_section/alert_section.module.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;;AAEtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".container {\n    font-family: Mulish, sans-serif;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    color: #8BA1D4CC;\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.body {\n    overflow-y: scroll;\n}\n\n.section {\n    display: flex;\n    justify-content: space-between;\n    padding: 0 20px;\n}\n\n.day {\n    flex-basis: 20%;\n}\n\n.alerts {\n    flex-basis: 75%;\n}\n\n.alert {\n    background-color: #FFFFFF;\n    border-radius: 12px;\n    display: flex;\n    padding: 12px;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.alertTitle {\n    font-size: 14px;\n    font-weight: 600;\n    text-align: left;\n}\n\n.alertTitle div:last-of-type {\n    color: #8C8C8C;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.alertDay {\n    color: #8C8C8C;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.alertValue {\n    background-color: #F5F5F5;\n    font-size: 24px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    vertical-align: bottom;\n    border-radius: 8px;\n    padding: 10px 12px;\n\n}\n\n.alertValue div:last-of-type {\n    padding-left: 4px;\n    color: #B7B7B7;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.alertDate {\n    color: #6A86C8;\n    font-size: 24px;\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `alert_section_container__x45qL`,
	"header": `alert_section_header__EBKN5`,
	"body": `alert_section_body__GdFNr`,
	"section": `alert_section_section__nSllO`,
	"day": `alert_section_day__BEPlA`,
	"alerts": `alert_section_alerts__H+MsQ`,
	"alert": `alert_section_alert__Fzi6l`,
	"alertTitle": `alert_section_alertTitle__L8cMi`,
	"alertDay": `alert_section_alertDay__w+cPM`,
	"alertValue": `alert_section_alertValue__xJVQa`,
	"alertDate": `alert_section_alertDate__gc-jo`
};
export default ___CSS_LOADER_EXPORT___;
